module.exports = __webpack_public_path__ + "static/media/Figure4.a3eb9306.jpg";